import { render, staticRenderFns } from "./CourseGroupDetail.vue?vue&type=template&id=53461bbb"
import script from "./CourseGroupDetail.vue?vue&type=script&lang=js"
export * from "./CourseGroupDetail.vue?vue&type=script&lang=js"
import style0 from "./CourseGroupDetail.vue?vue&type=style&index=0&id=53461bbb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports